var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 104,
    viewBox: "0 0 14 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08634 10.9725L13.1779 0.577831L1.11701 0.455861L5.99733 10.9513L8.08634 10.9725ZM5.16404 93.3499L0.0724709 103.744L12.1334 103.866L7.25305 93.371L5.16404 93.3499ZM6.00789 9.90682L5.15348 94.3944L7.24249 94.4155L8.0969 9.92795L6.00789 9.90682Z",
    fill: "#4083E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.36dd50e6022bd44ae2cb6a9dd9bc68a3.svg";
export { ForwardRef as ReactComponent };